import { render, staticRenderFns } from "./CurrencyCategoryEditComponent.vue?vue&type=template&id=51275ada"
import script from "./CurrencyCategoryEditComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyCategoryEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports